import { defineStore } from "pinia";
import { Quote } from "../../models/Quote";

import { QuoteInfo } from "@/models/QuoteInfo";
import { QuoteInsurance } from "@/models/QuoteInsurance";
import { Checkout } from "@/models/Checkout";
import { InsuranceAddress } from "@/models/InsuranceAddress";
import { Defaults } from "@/models/Defaults";
import { scrollTop } from "@/utils/Utils";

// type CreateMutable<T> = { -readonly [P in keyof T]: CreateMutable<T[P]> };

export const useQuoteStore = defineStore("quoteStore", {
  state: () => {
    const quote = new Quote();
    return { ...quote };
  },
  actions: {
    setQuoteStep(currentStep: string) {
      this.currentStep = currentStep;
      scrollTop();
    },
    //TODO WHY NEED ClearQuote doesnt clear only the quote Step
    clearQuote() {
      this.address = new InsuranceAddress();
      this.info = new QuoteInfo();
      this.rentersInsurance = new QuoteInsurance();
      this.personalInsurance = new QuoteInsurance();
      this.hasPersonalInsurance = undefined;
      this.checkout = new Checkout();
      this.processingFee = 0;
      this.monthlyProcessingFee = 0;
      this.done = false;
      this.nssiPassed = false;
      this.assurantPassed = false;
      this.assurantToken = "";
      this.assurantExpirationTime = "";
      this.currentStep = "";
      this.showAddressHelp = false;
      this.assurantPolicyError = "";
      this.nssiPolicyError = "";
      this.showAddonOnCart = false;
      this.folowUpMailSent = false;
      this.denialNotice = "";
      this.responseMessage = "";
    },
    saveDenialNotice(denialNotice: string) {
      this.denialNotice = denialNotice;
    },
    saveResponseMessage(responseMessage: string) {
      this.responseMessage = responseMessage;
    },
  },
  persist: true,
});
